import { render, staticRenderFns } from "./PaymentInfoDlg.vue?vue&type=template&id=c56c3a42&scoped=true&"
import script from "./PaymentInfoDlg.vue?vue&type=script&lang=js&"
export * from "./PaymentInfoDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56c3a42",
  null
  
)

export default component.exports